/* eslint-disable sort-keys */
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'container']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "container")[]
 * }>} BreadcrumbStyles
 */
export const breadcrumbStyles = helpers.defineMultiStyleConfig({
  baseStyle: {
    root: {
      alignItems: 'center',
      backgroundColor: 'primary.paleLinen',
      display: 'flex',
      marginTop: '48px',
      width: '100%',
    },
    container: {
      maxWidth: '1440px',
      marginX: 'auto',
      paddingX: {base: '20px', lg: '80px'},
      width: '100%',
      '& > *:last-child': {
        color: 'brandColors.greyscale80',
        fontWeight: '400',
      },
    },
  },
});
